import { useEffect } from "react";

import styled from "styled-components";

const ColorInfo = styled.div`

    & > .card-title{
            display: flex;
            background: #FFFFFF;
            position: relative;
            padding : 2px 15px 2px 15px;
            img{ width: 30px; margin-right: 10px;}
            border: 0.75px solid #E6E6E6;
            box-sizing: border-box;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 5px;
            margin-bottom: -20px;
           
            @media only screen and (max-width: 768px){
                width: 150px;
                justify-content: center;
                img{ width: 30px; margin-right: 10px;}
                margin-left: auto;
                margin-right: auto;
            }

            @media only screen and (max-width: 450px){
                width: 200px;
                justify-content: center;
                margin-left: auto;
                margin-right: auto;
                img{ width: 30px; margin-right: 10px;}
            }

            @media only screen and (max-width: 376px){
                width: 150px;
                justify-content: center;
                margin-left: auto;
                margin-right: auto;
                img{ width: 30px; margin-right: 10px;}
            }

            @media only screen and (min-width : 1200px){
                align-items: center;
                width: fit-content;
                margin-left: 20px;
                margin-right: 20px;
            }
        }
    
    & > .container{
        background-color: #405AA6;
        border: 1px solid #405AA6;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        width: 250px;
        color : white;
        padding: 25px 10px 20px 10px;
        display: flex;
        flex-direction: column;

        @media only screen and (max-width: 768px){
                width: 350px;
                justify-content: center;
        }

        @media only screen and (max-width: 450px){
                margin-bottom: 10px;
                width: 430px;
                justify-content: center;
        }

        @media only screen and (max-width: 376px){
            margin-bottom: 10px;
            width: 340px;
            justify-content: center;
        }

        & > .row{
            display: flex;
            justify-content: space-between;
            span{
                font-weight: normal;
                font-size: 16px;
            }
        }

    }
    
`

export default function Index(props) {

    useEffect(() => {

    }, []);

    return (
        <ColorInfo className={"card-summary-sensor" + (props.className ? props.className : "")}>
            <div className="card-title">
                <img src='/image/sensor.png' />
                <span>เซนเซอร์</span>
            </div>
            <div className="container">
                <div className="row"><span>จำนวนเซนเซอร์ทั้งหมด</span><span>{props.data.length ? props.data.length : 0 }</span></div>
                <div className="row"><span>จำนวนเซนเซอร์ที่เปิดสาธารณะ</span><span>{props.data.filter(item => item.allow_public).length}</span></div>
                <div className="row"><span>จำนวนที่เปิดใช้งาน</span><span>{props.data.filter(item => (item.status == 1)).length}</span></div>
                <div className="row"><span>จำนวนที่ปิดใช้งาน</span><span>{props.data.filter(item => (item.status == 0)).length}</span></div>
            </div>
        </ColorInfo>
    )
}
